import { functions } from '../firebase';
import { httpsCallable } from 'firebase/functions';

// Initialize the callable function
const submitContactForm = httpsCallable(functions, 'submitContactForm');

/**
 * Submit contact form data to Firebase Cloud Function
 * @param {Object} formData - Contact form data
 * @param {string} formData.name - User's name
 * @param {string} formData.email - User's email
 * @param {string} formData.subject - Message subject
 * @param {string} formData.message - Message content
 * @param {string} formData.userType - Type of user (student, company, other)
 * @returns {Promise<Object>} - Result with success status and submission ID
 */
export const submitContactFormData = async (formData) => {
  try {
    console.log('Submitting contact form:', formData);
    
    const result = await submitContactForm(formData);
    
    console.log('Contact form submitted successfully:', result.data);
    
    return {
      success: true,
      id: result.data.id,
      message: 'Your message has been sent successfully!'
    };
  } catch (error) {
    console.error('Error submitting contact form:', error);
    
    // Extract meaningful error message
    const errorMessage = error.message || 'Failed to send message. Please try again.';
    
    throw new Error(errorMessage);
  }
}; 